import { EMPTY_MASTER_MASTER_FSPANY_MODEL } from "presentation/model/MasterFSP/MasterFSPMaintenanceModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: MasterFSPMaintenanceProvider,
    useTracked: useMasterFSPMaintenanceTracked
} = createContainer(() => useState(EMPTY_MASTER_MASTER_FSPANY_MODEL), {concurrentMode: true});
export { MasterFSPMaintenanceProvider, useMasterFSPMaintenanceTracked };

